import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoAmex24 = t0 => {
  const $ = _c(4);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M5.32653 11.976L4.61398 10.2397L3.90551 11.976H5.32653ZM12.1609 13.8554L12.1569 10.4443L10.6474 13.8554H9.7333L8.2198 10.4413V13.8554H6.10239L5.70237 12.8839H3.53478L3.13069 13.8554H2L3.86426 9.5H5.411L7.18159 13.6237V9.5H8.88072L10.2431 12.4546L11.4947 9.5H13.228V13.8554H12.1609ZM14.8848 12.9642V12.0974H17.1704V11.2086H14.8848V10.4166H17.4949L18.6336 11.6861L17.4444 12.9642H14.8848ZM21.9383 13.8721H20.5856L19.3037 12.4299L17.9715 13.8721H13.8478V9.51563H18.0349L19.3158 10.9436L20.64 9.51563H22L19.9768 11.6939L21.9383 13.8721Z" fill="#002663" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== ariaLabel || $[2] !== className) {
    t2 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}</svg>;
    $[1] = ariaLabel;
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default IcoAmex24;